
























































































import {
  BroadcastMasterGetNotificationCountByMerchantId,
  BroadcastMasterGetNotificationListByMerchantId,
} from "@/broadcastChannel/userChannel";
import { LoadingStatusType, NotificationMessageType } from "@/enums/enums";
import {
  CheckMerchantIsActiveOtherTab,
  CheckMerchantIsLoadNotification,
  DoDeleteNotificationById,
  DoGetAllNotificationList,
  DoGetUnseenNotificationCount,
  DoSetNotificationIsSeenAll,
  ForceSetMaster,
  GetSuccessHeaderReport,
} from "@/helper/notificationHelper";
import { CheckIsDevelop, NewObject } from "@/helper/shareHelper";
import { IsMasterTab } from "@/helper/tabHelper";
import { ConvertFileUrlFromBlobStorageToFileService, OpenOrDownloadFileUrl } from "@/helper/uploadHelper";
import { MerchantId, UserId } from "@/helper/userHelper";
import { NotificationMessageModel } from "@/model/notification/NotificationMessageModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const StoreNotification = namespace("Notification");
@Component
export default class Notification extends Vue {
  private showNotification = false;
  private notiList: Array<NotificationMessageModel> = [];
  private isUpdateIsSeen = false;
  private isDevelop = CheckIsDevelop();
  private reloadThisMaster = true;
  private animation = false;

  @StoreNotification.Getter
  private getNotificationList!: Array<NotificationMessageModel>;
  @StoreNotification.Getter
  private getNotificationCount!: number;
  @StoreNotification.Getter
  private getNotificationIsConnect!: boolean;
  @StoreNotification.Getter
  private getNotificationReadyToUse!: boolean;
  @StoreNotification.Getter
  private getNotificationListLoadingStatus!: LoadingStatusType;
  @StoreNotification.Getter
  private getNotificationIsAuthenticated!: LoadingStatusType;

  @StoreNotification.Action
  private DoUpdateNotificationIsSeen!: () => void;
  @StoreNotification.Action
  private DoDeleteNotificationById!: (id: string) => void;

  created() {
    if (this.getNotificationReadyToUse) {
      this.GetNotificationCount();
    }
  }

  mounted() {
    const listBoxNotification: any = this.$refs.listBoxNotification;
    listBoxNotification.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("getNotificationListLoadingStatus")
  getNotificationListLoadingStatusChange(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      this.ResetDatalistDisplay();
    }
  }

  @Watch("getNotificationIsConnect")
  getNotificationIsConnectChanged(newVal: boolean) {
    if (!newVal) {
      this.showNotification = false;
    }
  }

  @Watch("getNotificationReadyToUse")
  getNotificationReadyToUseChanged(newVal: boolean) {
    if (!newVal) {
      this.showNotification = false;
    } else {
      this.GetNotificationCount();
    }
  }

  @Watch("getNotificationCount")
  getNotificationCountChange(newVal: number) {
    if (newVal > 0 && this.showNotification) {
      this.GetNotificationList();
    }
  }

  @Watch("showNotification")
  showNotificationChange(newVal: boolean) {
    if (!newVal) {
      this.reloadThisMaster = true;
      this.animation = false;
      this.notiList = [];
      if (this.isUpdateIsSeen) {
        const merchantId = MerchantId();
        DoSetNotificationIsSeenAll(merchantId);
        this.isUpdateIsSeen = false;
      }
    }
  }

  public HandleScroll() {
    const listBoxNotification: any = this.$refs.listBoxNotification;
    const scrollHeight = listBoxNotification.scrollHeight;
    const scrollTop = listBoxNotification.scrollTop;
    const clientHeight = listBoxNotification.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.notiList.length < this.getNotificationList.length) {
        this.notiList.push(this.getNotificationList[this.notiList.length]);
      }
    }
  }

  public ResetDatalistDisplay() {
    this.notiList = [];
    if (this.getNotificationList) {
      for (let i = 0; i < 10; i++) {
        if (i < this.getNotificationList.length) {
          this.notiList.push(this.getNotificationList[i]);
        }
      }
    }
  }

  public async GetNotificationCount() {
    const merchantId = MerchantId();
    const checkMerchantIsActiveOtherTab = await CheckMerchantIsActiveOtherTab(merchantId);
    if (IsMasterTab()) {
      DoGetUnseenNotificationCount(merchantId);
    } else {
      if (checkMerchantIsActiveOtherTab) {
        this.$store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
      } else {
        BroadcastMasterGetNotificationCountByMerchantId(merchantId);
      }
    }
  }

  public async GetNotificationList() {
    const merchantId = MerchantId();
    const checkMerchantIsLoadNotification = await CheckMerchantIsLoadNotification(merchantId);
    if (checkMerchantIsLoadNotification && this.getNotificationCount == 0) {
      this.$store.dispatch("Notification/ActionSetNotificationListFromIndexedDB", null, { root: true });
    } else {
      if (IsMasterTab()) {
        DoGetAllNotificationList(merchantId);
      } else {
        BroadcastMasterGetNotificationListByMerchantId(merchantId);
      }
      this.isUpdateIsSeen = true;
    }
  }

  public OnClickNotificationItemBox(messageTypeId: NotificationMessageType, messageUrl: string) {
    if (!this.CheckNotificationIsDepreciateAssetMonthly(messageTypeId)) {
      this.OpenNewTap(messageUrl);
    }
  }

  public CheckNotificationImport(messageTypeId: NotificationMessageType) {
    switch (messageTypeId) {
      case NotificationMessageType.ImportTransactionPurchaseInventory:
      case NotificationMessageType.ImportTransactionExpense:
      case NotificationMessageType.ImportTransactionInvoice:
      case NotificationMessageType.ImportTransactionReceipt:
      case NotificationMessageType.ImportTransactionQuotation:
      case NotificationMessageType.ImportTransactionPurchaseOrder:
      case NotificationMessageType.RecalCostOfGoodSoldByMerchantCalculated:
      case NotificationMessageType.RecalCostOfGoodSoldByProductCalculated:
      case NotificationMessageType.RecalCostOfGoodSoldFailed:
      case NotificationMessageType.VoidImportTransactionFailed:
      case NotificationMessageType.VoidImportTransactionSuccess:
        return true;
      default:
        return false;
    }
  }

  public CheckAffiliateNotification(messageTypeId: NotificationMessageType) {
    switch (messageTypeId) {
      case NotificationMessageType.RecieveBenefit:
      case NotificationMessageType.CamPaignBeforeExpire:
      case NotificationMessageType.BeforeExpireByDate:
      case NotificationMessageType.QuotaExpire:
        return true;
      default:
        return false;
    }
  }

  public CheckNotificationIsDepreciateAssetMonthly(messageTypeId: NotificationMessageType) {
    return messageTypeId === NotificationMessageType.DepreciateAssetMonthly;
  }

  public DoShowNotification() {
    if (this.getNotificationReadyToUse) {
      this.showNotification = this.showNotification ? false : true;
      if (this.showNotification) {
        this.GetNotificationList();
      }
    }
  }

  public OpenNewTap(linkDocument: string) {
    window.open(ConvertFileUrlFromBlobStorageToFileService(linkDocument));
  }

  public DownLoadDocument(linkDocument: string) {
    OpenOrDownloadFileUrl(linkDocument);
  }

  public RemoveNotification(notificationId: string, isSeen: boolean) {
    const merchantId = MerchantId();
    DoDeleteNotificationById(merchantId, notificationId, isSeen);
  }

  public hide(e: any, el: any) {
    this.showNotification = false;
  }

  public GetDateTimeFormat(_date: any) {
    const newDate = new Date(_date);

    const fullYear = newDate.getFullYear().toString();
    const month = (newDate.getMonth() + 1).toString();
    const date = newDate.getDate().toString();
    const hours = newDate.getHours().toString();
    const minutes = newDate.getMinutes().toString();

    return `${date.length == 2 ? date : "0" + date}/${month.length == 2 ? month : "0" + month}/${fullYear} ${
      hours.length == 2 ? hours : "0" + hours
    }:${minutes.length == 2 ? minutes : "0" + minutes}`;
  }

  public GetMessageNotification(messageTypeId: NotificationMessageType, messageDescription: string) {
    return GetSuccessHeaderReport(messageTypeId, messageDescription);
  }

  public async SetThisMaster() {
    this.animation = true;
    const merchantId = MerchantId();
    await ForceSetMaster(merchantId);
    setTimeout(() => {
      this.reloadThisMaster = false;
      this.animation = false;
    }, 1000);
  }
}
